/**
 |--------------------------------------------------------------------------
 | CALENDAR : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const calendar = [
 {
  path: '/calendar', component: require('pages/calendar/calendar.vue').default,
  name: 'calendar',
  meta: {requiresAuth: true, title: "Calendar", icon: "fas fa-calendar-alt"}
 }, {
  path: '/calendar/event/create', component: require('pages/calendar/create.vue').default,
  name: 'create_calendar_event',
  meta: {requiresAuth: true, title: "New Calendar Event", icon: "fas fa-calendar-plus"}
 },
];
export default calendar;
